var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalTokens(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 42,
    rx: 21,
    fill: "#F0F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25.5833H15.9166M18.4166 21H14.6666M20.5 16.4167H16.3333M27.1666 13.5L21.6696 21.1958C21.4263 21.5365 21.3046 21.7068 21.3099 21.8488C21.3145 21.9724 21.3738 22.0876 21.4717 22.1632C21.5842 22.25 21.7935 22.25 22.2121 22.25H26.3333L25.5 28.5L30.997 20.8042C31.2403 20.4635 31.3619 20.2932 31.3567 20.1512C31.3521 20.0276 31.2928 19.9124 31.1949 19.8368C31.0824 19.75 30.8731 19.75 30.4545 19.75H26.3333L27.1666 13.5Z",
    stroke: "#0BA5EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTokens);
export default __webpack_public_path__ + "static/media/totalTokens.6294f20816cae8d77e7da10133f93748.svg";
export { ForwardRef as ReactComponent };